import type { RecordView } from '@kit/sync/types/record-view';
import { createItem } from '@/entities/item/api/create-item';
import { patchShoppingItem } from '@/entities/shopping-item/api/patch-shopping-item';
import type { ShoppingItem } from '@/entities/shopping-item/schemas/shopping-item';
import type { IsoDate } from '@/shared/lib/dates/iso-date';
import { itemFromPurchase } from '../helpers/item-from-purchase';

type Purchase = {
  readonly priceCents: number | undefined;
  readonly boughtOn: IsoDate;
  /** Add it to the inventory, at this location and with this expiry. */
  readonly toInventory: { readonly location: string; readonly expiresOn: string } | null;
};

/** Mark an entry bought with what it really cost and, optionally, add it to the inventory. */
export async function recordPurchase(view: RecordView<ShoppingItem>, purchase: Purchase): Promise<void> {
  let itemId = view.data.item_id;
  if (purchase.toInventory) {
    itemId = await createItem({
      ...itemFromPurchase({ ...view.data, price_cents: purchase.priceCents }, purchase.boughtOn),
      location: purchase.toInventory.location,
      expires_on: purchase.toInventory.expiresOn,
    });
  }
  await patchShoppingItem(view.id, {
    status: 'bought',
    bought_on: purchase.boughtOn,
    price_cents: purchase.priceCents ?? null,
    item_id: itemId ?? null,
  });
}
